export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ21.d56b5294.mp3";